import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LayoutModule } from '@ui/layout/layout.module';
import { environment } from '@environments/environment';
import { CoreModule } from '@core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from '../material/material.module';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { MatCarouselModule } from 'ng-mat-carousel';

// ngx-ui-loader
import {
  NgxUiLoaderModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig, SPINNER, POSITION
} from 'ngx-ui-loader';


// ngx-ui-loader configuration
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#C4A3FF',
  fgsPosition: POSITION.centerCenter,
  fgsSize: 40,
  fgsType: SPINNER.squareJellyBox,
  overlayColor: 'rgba(40,40,40,.8)',
  fastFadeOut: true,
  hasProgressBar: false,
  text: 'Loading...',
  delay: 100
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    CoreModule,
    LayoutModule,
    CommonModule,
    MaterialModule,
    MatCarouselModule.forRoot(),
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderHttpModule.forRoot({
      showForeground: true
    })
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule { }
